import { Box, Dialog, DialogContent } from "@mui/material";
import { useDispatch } from "react-redux";
import { Category } from "./Category";
import {
  actions,
  queries,
} from "../../../../../../redux/features/account/accountSlice";
import { SubCategories } from "./SubCategories";
import { usePredefinedPanelConfiguration } from "./hooks/usePredefinedPanelConfiguration";
import { PreviewPredifinedPanel } from "./PreviewPredifinedPanel";
import { useEffect, useState } from "react";

import "./ConfigurePanelDialog.css";

export function ConfigurePanelDialog({
  isOpen,
  onClose,
  actions: actionsFromModule,
}) {
  const [isReady, setIsReady] = useState(false);

  const dispatch = useDispatch();

  const {
    categories,
    subcategories,
    predefinedPanels,
    selectedPrefinedPanels,
    onCategoryClick,
    onSubcategoryClick,
    onPanelClick,
    importPanelsToGridstack,
  } = usePredefinedPanelConfiguration(actionsFromModule, onClose, isOpen);

  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollHeight - (scrollTop + 30) <= clientHeight) {
      setIsReady(true);
    }
  };

  useEffect(() => {
    if (!isReady) return;

    const onScroll = async () => {
      dispatch(actions.incrementPage());
      await dispatch(queries.panels);
      await dispatch(queries.loadAllPredefinedPanels());
      setIsReady(false);
    };

    onScroll();
  }, [isReady]);

  useEffect(() => {
    if (predefinedPanels.length > 0) {
      setTimeout(() => {
        const panelsBody = document.querySelector(".panels-body");
        if (panelsBody) {
          const { scrollHeight, clientHeight } = panelsBody;

          if (scrollHeight <= clientHeight) {
            console.log(
              "No scroll detected, loading more content automatically"
            );
            setIsReady(true);
          }
        }
      }, 100);
    }
  }, [predefinedPanels.length]);

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogContent>
        <Box
          sx={{
            minWidth: "calc(100vw - 10rem)",
            minHeight: "calc(100vh - 10rem)",
          }}
        >
          <section className="configure-panel-dialog-header">
            <div className="title-info">
              <span className="title">Predefined Panel</span>
              <span className="subtitle">
                Please select one of the available categories to filter the
                panels.
              </span>
            </div>
            <div className="configure-panel-dialog-btns">
              <button className="filled" onClick={onClose}>
                Cancel
              </button>
              <button
                className={`filled ${
                  selectedPrefinedPanels.length
                    ? " greenButton"
                    : "no-selection"
                }`}
                onClick={importPanelsToGridstack}
                disabled={!selectedPrefinedPanels.length}
              >
                Import Panel Selected
                <div className="categories-counter">
                  <span>{selectedPrefinedPanels.length}</span>
                </div>
              </button>
            </div>
          </section>
          <section className="configure-panel-categories">
            {categories.length ? (
              categories.map((cat) => (
                <Category key={cat.id} item={cat} onClick={onCategoryClick} />
              ))
            ) : (
              <span style={{ fontSize: "25px", fontWeight: "bold" }}>
                No categories available
              </span>
            )}
          </section>
          <section className="configure-panel-config">
            <SubCategories items={subcategories} onClick={onSubcategoryClick} />
            <div className="panels">
              <div className="panels-header">
                <span className="title">Available Panels</span>
              </div>
              <div className="panels-body" onScroll={handleScroll}>
                {predefinedPanels.map((chart, index) => (
                  <PreviewPredifinedPanel
                    key={`${chart.id}-${index}`}
                    chart={chart}
                    onClick={onPanelClick}
                  />
                ))}
              </div>
            </div>
          </section>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
